export const isOnlyBasicUser = (user) => {
  if(!user || !user.roles) return false;
  return user.roles.length === 1 && user.roles[0].name?.toUpperCase() === "BASIC_USER";
}